'use strict'; // eslint-disable-line

/**
 * Converting the default select dropdown to unorder list HTML structure.
 */
function updateSelect() {
    $('.custom-select:not(select)').each(function () {
        var $this = $(this);
        if ($this.find('.selected-option').length === 0) {
            $this.append('<div class="selected-option"></div>');
        }
        if ($this.find('.selection-list').length === 0) {
            $this.append('<ul class="selection-list"></ul>');
        } else {
            $this.find('.selection-list').empty();
        }

        var $list = '';
        $this.find('option').each(function () {
            var $listClass = '';
            if ($(this).attr('class') && $(this).attr('class') !== undefined && $(this).attr('class') !== '') {
                $listClass += $(this).attr('class');
            }
            if ($(this).attr('disabled') === 'disabled') {
                $listClass += ' option-disabled';
            }
            $list += '<li label="' + $(this).text().trim().toLocaleLowerCase() + '" class="' + $listClass + '">' + $(this).text() + '</li>';
        });
        $this.find('.selection-list').append($list);

        var $selectedOptionText = $this.find('select option:selected').text();

        $this.find('.selected-option').text($selectedOptionText);

        $this.find('.selection-list li').removeClass('selected').removeClass('hover').eq($(this).find('select option:selected').index())
            .addClass('selected');

        if ($(this).find('select option:selected').val() !== '') {
            $this.find('.selected-option').addClass('selected');

            if ($(this).hasClass('birth-month')) {
                $this.find('.field-help-text').addClass('d-none');
            }
        } else {
            $this.find('.selected-option').removeClass('selected');

            if ($(this).hasClass('birth-month')) {
                $this.find('.field-help-text').removeClass('d-none');
            }
        }

        if ($this.find('.selection-list li .bold').length > 0) {
            $this.find('.selected-option').html($this.find('.selection-list li').eq($this.find('select option:selected').index()).html());
        }

        $this.find('li').removeClass('selected');
        $this.find('li').eq($(this).find('select option:selected').index()).addClass('selected');
        $this.find('.invalid-feedback').appendTo(this);

        if ($this.find('.field-help-text').length > 0) {
            $this.find('.field-help-text').appendTo(this);
        }

        if ($this.find('select').is(':disabled')) {
            $this.addClass('disabled');
        } else {
            $this.removeClass('disabled');
        }
    });
}

/** Scrolls the container so that the item is fully visible within the container's viewport, if it is not already.
 * @param {jQuery} $container - The scrollable container element.
 * @param {jQuery} $item - The item element to ensure visibility of.
 */
function ensureItemVisible($container, $item) {
    if (!$container.length || !$item.length) return;
    // Absolute coordinates
    const containerTop    = $container.offset().top;
    const containerHeight = $container.innerHeight();
    const scrollTop       = $container.scrollTop();
    const itemTopAbs      = $item.offset().top;
    const itemBottomAbs   = itemTopAbs + $item.outerHeight();
    // Convert absolute → container scroll coordinates
    const itemTop    = itemTopAbs - containerTop + scrollTop;
    const itemBottom = itemBottomAbs - containerTop + scrollTop;
    // Visibility window
    const viewTop    = scrollTop;
    const viewBottom = scrollTop + containerHeight;
    if (itemTop < viewTop) {
        // Scroll up so the item’s top aligns with the container’s top
        $container.scrollTop(itemTop);
    } else if (itemBottom > viewBottom) {
        // Scroll down so the item’s bottom aligns with the container’s bottom
        $container.scrollTop(itemBottom - containerHeight);
    }
}

/** Toggles the dropdown open/close when clicking or keypressing on the selected option, and sets the dropdown height and scroll position.
 * @remarks Only operates on custom-select wrapper elements that are not a native <select>, to avoid affecting templates where the <select> itself has class="custom-select".
 * @param {jQuery} $selectedOption - The selected option element that was clicked or keypressed.
 * @param {boolean} [closeOnly=false] - Optional flag to indicate that the dropdown should only be closed, not toggled open if it is currently closed.
 * @returns {boolean} True if the dropdown was toggled; otherwise, false if the click or keypress should not toggle the dropdown (e.g. when clicking on a disabled select).
 */
function toggleCustomSelect($selectedOption, closeOnly = false) {
    if (!$selectedOption.length) return false;
    var $selected = $selectedOption.eq(0);
    if ($selected.siblings('select').is(':disabled')) {
        return false;
    }
    var $customSelect = $selected.closest('.custom-select:not(select)');
    var $selectedOuterHeight = $selected.outerHeight();
    var $selectionList = $selected.siblings('.selection-list');

    // Close any other open dropdowns before toggling the current one, and remove hover state from their options
    var $otherCustomSelects = $('.custom-select:not(select)').not($customSelect);
    if ($otherCustomSelects.length > 0) {
        $otherCustomSelects.removeClass('current-item');
        $otherCustomSelects.find('li').removeClass('hover');
    }

    if (closeOnly) {
        $customSelect.removeClass('current-item');
    } else {
        $customSelect.toggleClass('current-item');
    }

    var $optionSelected = $customSelect.find('select option:selected');
    var $optionSelectedIndex = $optionSelected.length > 0 ? $optionSelected.index() : -1;

    // If the dropdown is closed after toggling, restore the selected item in the .selection-list and exit
    if (!$customSelect.hasClass('current-item')) {
        $customSelect.find('li').removeClass('hover');
        // Restore the selected item in the dropdown list based on the current selected option in the native select element,
        // in case it was changed while the dropdown was open
        if ($optionSelectedIndex >= 0) {
            $selectionList.children('li').eq($optionSelectedIndex).addClass('selected');
        }
        return true;
    }

    // Position the selection list right below the selected option and set its height and scroll position
    $selectionList.css('top', $selectedOuterHeight + 2);
    const $items = $selectionList.children('li:visible');
    if ($items.length > 10) {
        // Set the selection list height to the height of first 10 items
        const visibleWindowHeight = $items.slice(0, 10)
            .toArray()
            .reduce((sum, li) => sum + $(li).outerHeight(), 0);
        $selectionList.height(visibleWindowHeight);
        // Scroll so selected item is visible
        const $selectedLi = $items.filter('.selected').first();
        if ($selectedLi.length) {
            // Sum heights of all items before the selected one
            var offset = 0;
            const selectedIndex = $items.index($selectedLi);
            if (selectedIndex > 0) {
                offset = $items
                    .slice(0, selectedIndex - 1)
                    .toArray()
                    .reduce((sum, li) => sum + $(li).outerHeight(), 0);
            }
            $selectionList.scrollTop(offset);
        }
    } else {
        $selectionList.height('auto');
        $selectionList.scrollTop(0);
    }

    // Set hover state on the selected item in the dropdown list based on the current selected option in the native select element,
    // and ensure it is visible in the dropdown list
    $selectionList.children('li').removeClass('hover selected');
    if ($optionSelectedIndex >= 0) {
        var $selectedLi = $selectionList.children('li').eq($optionSelectedIndex);
        $selectedLi.addClass('hover');
        ensureItemVisible($selectionList, $selectedLi);
    }
    return true;
}

/**
 * Aligns the native select left position depending on platform (Mac vs others).
 * @param {boolean} isMac - True when running on a Mac/iOS platform.
 */
function syncNativeSelectLeft(isMac) {
    var left = isMac ? '0px' : '-9999px';
    $('.custom-select:not(select)').find('select').css({
        /* eslint-disable */
        left: left
        /* eslint-enable */
    });
}

/** Schedules a hover reset by removing hover from the "from" element and adding it back to the "to" element after a short delay.
 * @remarks When a user is hovering a list item and presses a navigation key, it briefly reverts hover to the original item. This prevents skipping items if another navigation key is pressed before the hover reset finishes.
 * @param {jQuery} $from - The element to remove hover from.
 * @param {jQuery} $to - The element to add hover back to.
 * @param {function} setIgnoring - A callback function to set whether navigation keypresses should be ignored during the hover reset delay.
 */
function scheduleHoverReset($from, $to, setIgnoring) {
    setIgnoring(true);
    setTimeout(() => {
        $from.removeClass('hover');
        $to.addClass('hover');
        setIgnoring(false);
    }, 100);
}

/**
 * Determine whether pointer interaction should move focus to the hidden native select.
 * iPhone/iPad Safari zooms when a small hidden select receives focus from a tap, so skip
 * the programmatic focus for iOS touch interactions and keep keyboard focus behavior elsewhere.
 *
 * @returns {boolean} True when pointer interaction should focus the native select.
 */
function shouldFocusNativeSelectOnPointerDown() {
    var isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    return !(isIOSDevice && isTouchDevice);
}

module.exports = {
    updateSelect: updateSelect,
    selectbox: function () {
        this.updateSelect();

        var $lastMouseDownCustomSelect = null;
        var ignoreNavigationKeypressesDuringListItemHoverReset = false;

        $(document).on('mousedown', function (e) {
            $lastMouseDownCustomSelect = null;
            var $target = $(e.target);
            if ($target.is(':disabled')) {
                return;
            }
            var $customSelect = $target.closest('.custom-select:not(select)');
            if ($customSelect.length === 0) {
                return;
            }
            var $selected = $target.closest('.selected-option');
            var $optionArea = $target.closest('.selection-list li');
            var isSelectedClicked = $selected.length > 0 && $.contains($customSelect[0], $selected[0]);
            var isOptionAreaClicked = $optionArea.length > 0 && $.contains($customSelect[0], $optionArea[0]);
            if (isSelectedClicked || isOptionAreaClicked) {
                if (shouldFocusNativeSelectOnPointerDown()) {
                    // Prevent focus loss when pressing and holding mouse button on dropdown
                    e.preventDefault();
                    $customSelect.find('select').focus();
                    // Store the custom select that was clicked, to prevent its select element from losing focus on blur
                    $lastMouseDownCustomSelect = $customSelect;
                }
            }
        }).on('blur', '.custom-select select', function () {
            var $this = $(this);
            var $customSelect = $this.parent().closest('.custom-select');
            // Prevent select from losing focus when dropdown is open for the same instance
            if ($customSelect.hasClass('current-item') &&
                $lastMouseDownCustomSelect &&
                $customSelect.is($lastMouseDownCustomSelect)) {
                setTimeout(function () {
                    $this.focus();
                }, 0);
            }
        }).on('click', '.selected-option', function () {
            window.$currentkeycode = '';
            const isToggled = toggleCustomSelect($(this));
            return !isToggled;
        }).on('mouseenter', '.selection-list li', function () {
            var $this = $(this);
            if ($this.hasClass('option-disabled')) {
                return false;
            }
            // Ensure the item selected after any keypress that changes the selection is visible before applying hover to the item under the mouse
            const $selectionList = $this.parent();
            const $selectedLi = $selectionList.children('li.selected').first();
            if ($selectedLi.length > 0 && $selectedLi.index() !== $this.index()) {
                ensureItemVisible($selectionList, $selectedLi);
            }
            $this.siblings().addBack().removeClass('hover selected');
            $this.addClass('hover');
            return true;
        }).on('click', '.selection-list li', function () {
            var $this = $(this);
            var $customSelect = $this.closest('.custom-select:not(select)');
            if (($customSelect.find('#billingAddressSelector').length >= 1 && $customSelect.find('select option').eq($this.index()).attr('value')) === ($customSelect.find('.selected-option.selected').attr('value'))) {
                $customSelect.removeClass('current-item'); // the same option is selected, just close the dropdown
                return false;
            }
            if ($customSelect.find('#billingAddressSelector').length < 1 && ($customSelect.find('select option').eq($this.index()).text()) === ($customSelect.find('.selected-option.selected').text())) {
                $customSelect.removeClass('current-item'); // the same option is selected, just close the dropdown
                return false;
            }
            if ($this.hasClass('option-disabled')) {
                return false;
            }
            $customSelect.find('li').removeClass('hover selected');
            $this.addClass('selected');
            $customSelect.find('select option').eq($this.index()).prop('selected', true);
            $customSelect.find('.selected-option').text($this.text());

            $customSelect.removeClass('current-item');
            $customSelect.find('select').trigger('change');
            if ($customSelect.find('.selected-option').text().trim() === '') {
                $customSelect.find('label').removeClass('input-focus');
            } else {
                $customSelect.find('label:not(".input-focus")').addClass('input-focus');
            }
            return true;
        }).on('change input', 'select', function () {
            updateSelect();
        });

        $(document).on('click', function (e) {
            var $target = $(e.target);
            var $customSelects = $('.custom-select.current-item:not(select)');
            $customSelects.each(function () {
                var $customSelect = $(this);
                if (!$customSelect.is($target) && !$customSelect.find('*').is($target)) {
                    toggleCustomSelect($customSelect.find('.selected-option'), true);
                }
            });
        });

        $('body').off('keydown.formFields').on('keydown.formFields', function (e) {
            $lastMouseDownCustomSelect = null;
            /* eslint-disable */
            var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
            var $activeCustomSelect = $('.custom-select.current-item:not(select)');
            var $mac = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
            /* eslint-enable */
            var isCustomSelectToggled = false;
            var isPrintableCharKey = key >= 48 && key <= 90; // Alphanumeric keys only

            if ($activeCustomSelect.length > 0) {
                $activeCustomSelect.find('select').focus();
                $activeCustomSelect.addClass('current-item');
                var $selectionList = $activeCustomSelect.find('.selection-list');
                var $list = $activeCustomSelect.find('li');
                var $selectedLi = $activeCustomSelect.find('li.selected');
                var $activeLi;

                if (typeof window.$currentkeycode !== 'string') {
                    window.$currentkeycode = '';
                }
                if (key === 8) { // Delete key
                    window.$currentkeycode = window.$currentkeycode.slice(0, -1);
                } else if (isPrintableCharKey) {
                    window.$currentkeycode += $.trim(String.fromCharCode(key).toLowerCase());
                }
                $activeLi = $activeCustomSelect.find('li[label^="' + window.$currentkeycode + '"]');

                if (isPrintableCharKey && $activeLi.length === 0) {
                    window.$currentkeycode += $.trim(String.fromCharCode(key));
                    window.$currentkeycode = window.$currentkeycode.substr(window.$currentkeycode.length - 1, 1);
                    $activeLi = $activeCustomSelect.find('li[label^="' + window.$currentkeycode + '"]');
                }

                if (key === 40 || key === 35 || key === 34) { // Down or End or Page Down key
                    if (ignoreNavigationKeypressesDuringListItemHoverReset) {
                        return false;
                    }
                    $activeLi = $activeCustomSelect.find('li.hover');
                    if ($activeLi.length === 0 && $selectedLi.length > 0) {
                        $activeLi = $selectedLi;
                    }
                    const $nextLi = $activeLi.next();
                    if ($nextLi.length > 0) {
                        $activeLi.siblings().addBack().removeClass('hover selected');
                        const $subsequentLi = key === 40 ? $nextLi : $activeLi.siblings(':last');
                        if ($activeLi.is(':hover')) {
                            $nextLi.addClass('hover');
                            ensureItemVisible($selectionList, $nextLi);
                            scheduleHoverReset($nextLi, $activeLi, (v) => { ignoreNavigationKeypressesDuringListItemHoverReset = v; });
                        } else {
                            $subsequentLi.addClass('hover');
                            ensureItemVisible($selectionList, $subsequentLi);
                        }
                    }
                    return false;
                }
                if (key === 38 || key === 36 || key === 33) { // Up or Home or Page Up key
                    if (ignoreNavigationKeypressesDuringListItemHoverReset) {
                        return false;
                    }
                    $activeLi = $activeCustomSelect.find('li.hover');
                    if ($activeLi.length === 0 && $selectedLi.length > 0) {
                        $activeLi = $selectedLi;
                    }
                    const $prevLi = $activeLi.prev();
                    if ($prevLi.length > 0) {
                        $activeLi.siblings().addBack().removeClass('hover selected');
                        const $subsequentLi = key === 38 ? $prevLi : $activeLi.siblings(':first');
                        if ($activeLi.is(':hover')) {
                            $prevLi.addClass('hover');
                            ensureItemVisible($selectionList, $prevLi);
                            scheduleHoverReset($prevLi, $activeLi, (v) => { ignoreNavigationKeypressesDuringListItemHoverReset = v; });
                        } else {
                            $subsequentLi.addClass('hover');
                            ensureItemVisible($selectionList, $subsequentLi);
                        }
                    }
                    return false;
                }
                if (key === 13 || key === 32) { // Enter or Space key
                    if ($activeLi.length === 0) {
                        $activeLi = $activeCustomSelect.find('li.hover');
                    }
                    if ($activeLi.length > 0) {
                        $activeLi.eq(0).trigger('click');
                        isCustomSelectToggled = true;
                    } else {
                        isCustomSelectToggled = toggleCustomSelect($activeCustomSelect.find('.selected-option'), true);
                    }
                    syncNativeSelectLeft($mac);
                    return !isCustomSelectToggled;
                }
                if (key === 9 || key === 27) { // Tab or Escape key
                    toggleCustomSelect($activeCustomSelect.find('.selected-option'), true);
                    syncNativeSelectLeft($mac);
                } else if ($activeLi.length !== 0) {
                    $list.removeClass('hover');
                    $activeLi.eq(0).addClass('hover');
                }
                if (key === 8) { // Delete key
                    return false;
                }
                // Ensure the item selected after any keypress that changes the selection is visible,
                // including character keypresses that jump to items by their label.
                setTimeout(() => {
                    $selectedLi = $selectionList.find('li.selected');
                    if ($selectedLi.length > 0) {
                        ensureItemVisible($selectionList, $selectedLi);
                    }
                }, 0);
            } else {
                var $target = $(e.target);
                var $customSelect = $target.closest('.custom-select:not(select)');
                if ($customSelect.length === 0) {
                    return true;
                }
                if (key === 13 || key === 32) {
                    isCustomSelectToggled = toggleCustomSelect($customSelect.find('.selected-option'));
                    syncNativeSelectLeft($mac);
                    return !isCustomSelectToggled;
                }
            }
            return true;
        });
    }
};
